<template>
  <div class="edit-profile">
    <TitleBar :text="$t('EditProfile.topic')" :enableIconButton="false" @clickCloseButton="clickCloseButton" />
    <div class="body">
      <form>
        <div class="field password" v-if="!isResetPassword">
          <label>{{ $t('EditProfile.password') }}</label>
          <input name="password" type="password" :placeholder="$t('EditProfile.passwordPlaceholder')" v-model="password">
        </div>
        <div class="field new-password">
          <label>{{ $t('EditProfile.newPassword') }}</label>
          <input name="newPassword" type="password" :placeholder="$t('EditProfile.newPasswordPlaceholder')" v-model="newPassword">
        </div>
        <div class="field confirm-new-password">
          <label>{{ $t('EditProfile.confirmNewPassword') }}</label>
          <input name="confirmNewPassword" type="password" :placeholder="$t('EditProfile.confirmNewPasswordPlaceholder')" v-model="confirmNewPassword">
        </div>
      </form>
      <button class="submit-btn" @click="submit">{{ $t('EditProfile.save') }}</button>
    </div>
    <div v-if="false" class="loading-animation-container">
      <div class="loading-animation primary"></div>
    </div>
  </div>
</template>

<script>
import TitleBar from '@/components/TitleBar.vue'

export default {
  name: 'EditProfile',
  components: {
    TitleBar
  },
  props: {
    isResetPassword: {
      type: Boolean,
      default: false
    },
    oneTimeToken: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      password: '',
      newPassword: '',
      confirmNewPassword: ''
    }
  },
  methods: {
    clickCloseButton () {
      var self = this
      self.$router.back()
    },
    submit () {
    }
  }
}
</script>

<style scoped>
  .edit-profile {
    height: fit-content;
    width: 320px;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    position: relative;
    overflow: hidden;
    margin-top: auto;
    margin-bottom: auto;
  }

  .body {
    padding: 16px;
    background: rgb(255, 255, 255);
    display: flex;
    flex-direction: column;
  }

  .field {
    display: flex;
    flex-direction: column;
  }

  input {
    width: 100%;
    background: rgb(255, 255, 255);
    border: 1px solid rgb(120, 120, 120);
    border-radius: 4px;
    margin: 0px 0px 8px 0px;
    padding: 10px;
    line-height: 1.75;
    color: rgb(74, 74, 74);
    box-sizing: border-box;
    height: 40px;
  }

  ::-webkit-input-placeholder {
    line-height: 1.75;
    color: rgb(120, 120, 120);
  }

  .submit-btn {
    width: 100%;
    padding: 6px;
    background: rgb(59, 144, 255);
    border-radius: 4px;
    border: none;
    color: rgb(255, 255, 255);
    margin: 8px 0px 8px 0px;
    cursor: pointer;
  }

  .loading-animation-container {
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.6);
  }
</style>



// WEBPACK FOOTER //
// src/components/EditProfile.vue